import styled from 'styled-components/native';

export default styled.View<{ isLive?: boolean }>`
  border-radius: ${({ isLive }) => (isLive ? '6px' : '7px')};
  flex: 1;
  overflow: hidden;
  width: 100%;
`;
